import React from 'react';

export type PartnershipProduct = {
  title: string;
  copy: string;
};

// Bordered text card (design-system pattern) for the /partners "How we work
// with partners" grid. Add/reorder cards by editing the data array in
// PartnersPage — never by touching this layout.
const PartnershipCard: React.FC<PartnershipProduct> = ({ title, copy }) => (
  <div className="border border-ink/10 rounded-3xl p-7 md:p-8 bg-white">
    <h3
      className="font-display font-medium text-ink text-[20px] md:text-[22px] mb-2"
      style={{ lineHeight: 1.15, letterSpacing: '-0.015em' }}
    >
      {title}
    </h3>
    <p className="text-[15px] md:text-[16px] text-ink/70" style={{ lineHeight: 1.55 }}>
      {copy}
    </p>
  </div>
);

export default PartnershipCard;
